import { ClientEventEmitter } from '../../marketing/ClientEventEmitter';
import { ClientEvents } from '../../constants/clientEvents';

export class Marches9Handler {
    public handle(): void {
        ClientEventEmitter.fireEvent(ClientEvents.MARCHES_9);
    }
}
